<button class="toggle-btn" (click)="toggleSidebar()">
  <nz-icon nzType="menu" nzTheme="outline"></nz-icon>
</button>

<nz-sider
  nzCollapsible
  [(nzCollapsed)]="isCollapsed"
  [nzTrigger]="null"
  [ngClass]="{'is-collapsed': !isCollapsed, 'admin-theme': userType === 'admin', 'cajero-theme': userType === 'cajero'}">

  <div class="header">
    <img class="logo" loading="lazy" alt="Logo Muni" src="../../../assets/logo.png" />
    <h1 class="title" *ngIf="!isCollapsed">{{ userType === 'admin' ? 'Administrador' : 'Cajero' }}</h1>
  </div>

  <ul nz-menu nzTheme="dark" nzMode="inline">
    <li *ngIf="userType === 'admin'" nz-menu-item [routerLink]="['/admin/directorio']" routerLinkActive="active" [nzSelected]="isActive('/admin/directorio')">
      <nz-icon nzType="team" nzTheme="outline"></nz-icon>
      <span>Directorio</span>
    </li>
    <li *ngIf="userType === 'admin'" nz-menu-item [routerLink]="['/admin/reservas']" routerLinkActive="active" [nzSelected]="isActive('/admin/reservas')">
      <nz-icon nzType="read" nzTheme="outline"></nz-icon>
      <span>Reservas</span>
    </li>
    <li *ngIf="userType === 'admin'" nz-menu-item [routerLink]="['/admin/calendar']" routerLinkActive="active" [nzSelected]="isActive('/admin/calendar')">
      <nz-icon nzType="calendar"></nz-icon>
      <span>Calendario</span>
    </li>
    <li *ngIf="userType === 'admin'" nz-menu-item [routerLink]="['/admin/tarifario']" routerLinkActive="active" [nzSelected]="isActive('/admin/tarifario')">
      <nz-icon nzType="tag" nzTheme="outline"></nz-icon>
      <span>Tarifario</span>
    </li>
    <li *ngIf="userType === 'cajero'" nz-menu-item [routerLink]="['/cajero/reservas-cajero']" routerLinkActive="active" [nzSelected]="isActive('/cajero/reservas-cajero')">
      <nz-icon nzType="file"></nz-icon>
      <span>Reservas</span>
    </li>
    <li nz-menu-item (click)="logout()">
      <nz-icon nzType="logout" nzTheme="outline"></nz-icon>
      <span>Logout</span>
    </li>
  </ul>
</nz-sider>
